import { SafRegistryError } from './errors';

/**
 * Error thrown when the request is aborted
 */
export class SafRequestAbortedError extends SafRegistryError {
	public constructor(cause?: Error) {
		super('Request was aborted', cause);
	}
}
